/* cart-fast.js - faster cart quantity updates (debounced, 1 request instead of 2) + Remove button in the cart drawer. Needs sections/cart-ajax-items.liquid */
(function () {
if (window.__cartFast || !window.theme) return;
window.__cartFast = true;
var SECTION = 'cart-ajax-items';
var DELAY = 300;
var timers = {};
var inflight = 0;
var queue = Promise.resolve();

var st = document.createElement('style');
st.textContent = '.drawer .cart__remove{display:block}' +
'.drawer .cart__item-sub>div:first-child{display:flex;align-items:center;flex-wrap:wrap;gap:6px 16px}' +
'.drawer .cart__remove a{margin-top:0;font-size:0;line-height:0;display:inline-flex;padding:4px;border:0;text-decoration:none;opacity:.7}' + '.drawer .cart__remove a:hover{opacity:1}' + '.drawer .cart__remove a::before{content:"";width:18px;height:18px;background:currentColor;-webkit-mask:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6%27/%3E%3C/svg%3E") center/contain no-repeat;mask:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27black%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6%27/%3E%3C/svg%3E") center/contain no-repeat}' +
'.cart__item.cart-fast--removing{opacity:.4;pointer-events:none;transition:opacity .2s}';
document.head.appendChild(st);

function cartForms() {
return Array.prototype.filter.call(document.querySelectorAll('form[data-location]'), function (f) { return f.querySelector('[data-products]'); });
}
function money(c) { return theme.Currency.formatMoney(c, theme.settings.moneyFormat); }
function setBusy(on) {
cartForms().forEach(function (f) { var b = f.querySelector('.cart__checkout'); if (b) b.classList.toggle('btn--loading', on); });
}

function render(html) {
var tmp = document.createElement('div');
tmp.innerHTML = html;
var items = tmp.querySelector('.cart__items');
if (!items) return false;
var disc = tmp.querySelector('.cart__discounts');
var count = parseInt(items.getAttribute('data-count'), 10) || 0;
var subtotal = items.getAttribute('data-cart-subtotal');
cartForms().forEach(function (form) {
var ns = '.cart-' + form.getAttribute('data-location');
var products = form.querySelector('[data-products]');
products.innerHTML = '';
products.appendChild(items.cloneNode(true));
var d = form.querySelector('[data-discounts]');
if (d && disc) { d.innerHTML = ''; d.appendChild(disc.cloneNode(true)); }
var s = form.querySelector('[data-subtotal]');
if (s) s.innerHTML = money(subtotal);
var sv = form.querySelector('[data-savings]');
if (sv) sv.classList.add('hide');
form.parentNode.classList.toggle('is-empty', count <= 0);
products.querySelectorAll('.js-qty__wrapper').forEach(function (el) { new theme.QtySelector(el, { namespace: ns, isCart: true }); });
});
document.querySelectorAll('.cart-link__bubble-num').forEach(function (el) { el.innerText = count; });
document.querySelectorAll('.cart-link__bubble').forEach(function (b) { b.classList.toggle('cart-link__bubble--visible', count > 0); });
if (window.AOS) AOS.refreshHard();
if (window.Shopify && Shopify.StorefrontExpressButtons) Shopify.StorefrontExpressButtons.initialize();
return true;
}

function fullRefresh() {
return fetch(theme.routes.cartPage + '?view=ajax&t=' + Date.now(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(render);
}

function send(key, qty) {
inflight++;
setBusy(true);
queue = queue.then(function () {
return fetch(theme.routes.cartChange, {
method: 'POST',
credentials: 'same-origin',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
body: JSON.stringify({ id: key, quantity: qty, sections: SECTION, sections_url: theme.routes.cartPage })
}).then(function (r) { return r.json(); }).then(function (cart) {
if (!cart.items) {
if (cart.description || cart.message) alert(cart.description || cart.message);
return fullRefresh();
}
if (inflight === 1 && !Object.keys(timers).length) {
var html = cart.sections && cart.sections[SECTION];
if (!html || !render(html)) return fullRefresh();
}
document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
}).catch(function (e) {
console.error(e);
return fullRefresh().catch(function () {});
}).then(function () {
inflight--;
if (!inflight) setBusy(false);
});
});
}

function schedule(key, qty, el) {
if (el) el.classList.add('is-loading');
if (qty === 0) {
document.querySelectorAll('.cart__item[data-key="' + key + '"]').forEach(function (i) { i.classList.add('cart-fast--removing'); });
}
clearTimeout(timers[key]);
timers[key] = setTimeout(function () { delete timers[key]; send(key, qty); }, qty === 0 ? 0 : DELAY);
}

/* take over the theme's quantity handler (runs before it, in capture phase) */
function onQty(evt) {
var d = evt.detail;
if (!d || !d[0] || typeof d[1] !== 'number' || isNaN(d[1])) return;
evt.stopImmediatePropagation();
evt.stopPropagation();
schedule(d[0], d[1], d[2]);
}
var hooked = {};
function hook(loc) {
if (!loc || hooked[loc]) return;
hooked[loc] = true;
window.addEventListener('cart:quantity.cart-' + loc, onQty, true);
}
['cart-drawer', 'page', 'header'].forEach(hook);
document.querySelectorAll('form[data-location]').forEach(function (f) { hook(f.getAttribute('data-location')); });

/* Remove link: ajax instead of full page reload */
document.addEventListener('click', function (e) {
var a = e.target.closest && e.target.closest('.cart__remove a');
if (!a) return;
var item = a.closest('.cart__item');
if (!item || !item.getAttribute('data-key')) return;
e.preventDefault();
e.stopPropagation();
schedule(item.getAttribute('data-key'), 0, null);
}, true);
})();
